import { productStatusLabel, productStatusTone } from "../lib/productEnums";

const TONES = {
  green: "bg-emerald-500/12 text-emerald-300 border-emerald-500/30",
  amber: "bg-amber-500/12 text-amber-300 border-amber-500/30",
  red:   "bg-red-500/12 text-red-300 border-red-500/30",
  slate: "bg-white/5 text-slate-300 border-white/10",
};

const DOT = {
  green: "bg-emerald-400",
  amber: "bg-amber-400",
  red:   "bg-red-400",
  slate: "bg-slate-400",
};

export function ProductStatusPill({ value }) {
  if (value === null || value === undefined || value === "") return <span className="text-slate-500">—</span>;
  const tone = productStatusTone(value);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border ${TONES[tone]}`}
      data-testid={`product-status-pill-${value}`}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${DOT[tone]}`} />
      {productStatusLabel(value)}
    </span>
  );
}
